import React from 'react';
import {ADVANTAGE_KIND, MAX_ADVANTAGE_LEVEL, createAdvantage} from '../../character';
import {ADVANTAGE_POINTS, FLAW_POINTS} from '../../data/creation';
import {vtmT} from '../../i18n';
import {DotPicker} from './CreationParts';

const AdvantageEditor = ({item, onChange, onRemove, idPrefix}) => (
  <li className="vtmAdvantageEditor">
    <div className="vtmAdvantageEditorRow">
      <input
        id={`${idPrefix}-name`}
        type="text"
        aria-label={vtmT('advantageName')}
        placeholder={vtmT('advantageName')}
        value={item.name}
        onChange={event => onChange({name: event.target.value})}
      />
      <DotPicker value={item.level} min={1} max={MAX_ADVANTAGE_LEVEL} label={item.name || vtmT('advantageLevel')} onChange={level => onChange({level})} />
      <button type="button" className="vtmIconButton" onClick={onRemove} aria-label={`${vtmT('remove')} ${item.name}`}>×</button>
    </div>
    <input
      id={`${idPrefix}-description`}
      type="text"
      aria-label={vtmT('advantageDescription')}
      placeholder={vtmT('advantageDescription')}
      value={item.description || ''}
      onChange={event => onChange({description: event.target.value})}
    />
  </li>
);

const AdvantageSection = ({title, kind, source, budget, sheet, change}) => {
  const indexed = sheet.advantages.map((item, index) => ({item, index})).filter(({item}) => item.kind === kind && item.source === source);
  const spent = indexed.reduce((sum, {item}) => sum + (item.level || 0), 0);
  const update = (index, patch) => change({
    ...sheet,
    advantages: sheet.advantages.map((item, i) => (i === index ? {...item, ...patch} : item)),
  });
  const remove = (index) => change({...sheet, advantages: sheet.advantages.filter((_, i) => i !== index)});
  const add = () => change({...sheet, advantages: [...sheet.advantages, createAdvantage({kind, source})]});
  const state = budget === undefined ? '' : (spent === budget ? 'ok' : (spent > budget ? 'over' : 'under'));

  return (
    <section className="vtmAdvantageSection">
      <div className="vtmAdvantageSectionHeader">
        <h3 className="vtmCategoryTitle">{title}</h3>
        {budget !== undefined && <span className={`vtmDistributionChip ${state}`}>{vtmT('budget', {spent, total: budget})}</span>}
      </div>
      <ul className="vtmAdvantageEditors">
        {indexed.map(({item, index}) => (
          <AdvantageEditor
            key={index}
            idPrefix={`vtmAdv-${index}`}
            item={item}
            onChange={patch => update(index, patch)}
            onRemove={() => remove(index)}
          />
        ))}
      </ul>
      <button type="button" className="vtmButton small" onClick={add}>{vtmT('add')}</button>
    </section>
  );
};

export const AdvantagesStep = ({sheet, change}) => (
  <div className="vtmAdvantagesStep">
    <AdvantageSection title={vtmT('advantages')} kind={ADVANTAGE_KIND.ADVANTAGE} source="creation" budget={ADVANTAGE_POINTS} sheet={sheet} change={change} />
    <AdvantageSection title={vtmT('flaws')} kind={ADVANTAGE_KIND.FLAW} source="creation" budget={FLAW_POINTS} sheet={sheet} change={change} />
    <AdvantageSection title={`${vtmT('fromPredator')} · ${vtmT('advantages')}`} kind={ADVANTAGE_KIND.ADVANTAGE} source="predator" sheet={sheet} change={change} />
    <AdvantageSection title={`${vtmT('fromPredator')} · ${vtmT('flaws')}`} kind={ADVANTAGE_KIND.FLAW} source="predator" sheet={sheet} change={change} />
  </div>
);
